// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/react-spinkit/css/wave.css
// module id = 1238
// module chunks = 0